/* stylelint-disable scss/dollar-variable-colon-space-after */
/* stylelint-disable scss/dollar-variable-colon-space-after */
/* stylelint-disable scss/dollar-variable-colon-space-after */
/* stylelint-disable scss/dollar-variable-colon-space-after */
/* stylelint-disable scss/dollar-variable-colon-space-after */
.display1 {
  font-size: 48px;
  font-weight: normal;
  line-height: 125%;
}
.display1.bold,
.display1 .bold {
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .display1 {
    font-size: 30px;
    line-height: 150%;
  }
}

.display2 {
  font-size: 40px;
  font-weight: normal;
  line-height: 125%;
}
.display2.bold,
.display2 .bold {
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .display2 {
    font-size: 27px;
    line-height: 150%;
  }
}

.display3 {
  font-size: 36px;
  font-weight: normal;
  line-height: 125%;
}
.display3.bold,
.display3 .bold {
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .display3 {
    font-size: 24px;
    line-height: 150%;
  }
}

.heading1 {
  font-size: 24px;
  font-weight: normal;
  line-height: 150%;
}
.heading1.bold,
.heading1 .bold {
  font-weight: 600;
}

.heading2 {
  font-size: 20px;
  font-weight: normal;
  line-height: 150%;
}
.heading2.bold,
.heading2 .bold {
  font-weight: 600;
}

.heading3 {
  font-size: 18px;
  font-weight: normal;
  line-height: 150%;
}
.heading3.bold,
.heading3 .bold {
  font-weight: 600;
}

.heading4 {
  font-size: 16px;
  font-weight: normal;
  line-height: 150%;
}
.heading4.bold,
.heading4 .bold {
  font-weight: 600;
}

.subheading1 {
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 150%;
  text-transform: uppercase;
}

.subheading2 {
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 150%;
  text-transform: uppercase;
}

.subheading3 {
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 150%;
  text-transform: uppercase;
}

.body1 {
  font-size: 16px;
  font-weight: normal;
  line-height: 150%;
}
.body1.bold,
.body1 .bold {
  font-weight: 600;
}

.body2 {
  font-size: 14px;
  font-weight: normal;
  line-height: 150%;
}
.body2.bold,
.body2 .bold {
  font-weight: 600;
}

.body3 {
  font-family: "Red Hat Text", "Helvetica", sans-serif;
  font-size: 12px;
  font-weight: normal;
  line-height: 150%;
}
.body3.bold,
.body3 .bold {
  font-weight: 600;
}

.button1 {
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 100%;
  text-transform: uppercase;
}

.button2 {
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 100%;
  text-transform: uppercase;
}

.link1 {
  font-size: 16px;
  font-weight: normal;
  line-height: 150%;
  text-decoration-line: underline;
}
.link1.bold,
.link1 .bold {
  font-weight: 600;
}

.link2 {
  font-size: 14px;
  font-weight: normal;
  line-height: 150%;
  text-decoration-line: underline;
}
.link2.bold,
.link2 .bold {
  font-weight: 600;
}

.link3 {
  font-size: 12px;
  font-weight: normal;
  line-height: 150%;
  text-decoration-line: underline;
}
.link3.bold,
.link3 .bold {
  font-weight: 600;
}

.small-label1 {
  font-size: 12px;
  font-weight: bold;
  line-height: 100%;
  text-transform: uppercase;
}

.small-label2 {
  font-size: 10px;
  font-weight: bold;
  line-height: 100%;
  text-transform: uppercase;
}

.cursor-pointer {
  cursor: pointer;
}

.underline {
  text-decoration: underline;
}

.uppercase {
  text-transform: uppercase;
}

.lowercase {
  text-transform: lowercase;
}

.no-text-transform {
  text-transform: none;
}

.gray {
  color: #a6a6a6;
}

.light-gray {
  color: #ccc;
}

.lighter-gray {
  color: #eaeaea;
}

.lightest-gray {
  color: #f5f5f5;
}

.dark-gray {
  color: #767676;
}

.darker-gray {
  color: #606060;
}

.darkest-gray {
  color: #404040;
}

.purple {
  color: #5b1dc2;
}

.dark-purple {
  color: #4b18a1;
}

.white {
  color: #fff;
}

.black {
  color: #000;
}

.red {
  color: #fd868c;
}

.darker-red {
  color: #d43838;
}

.dark-orange {
  color: #ff8313;
}

.center {
  text-align: center;
}

.right {
  text-align: right;
}

.normal {
  font-weight: normal;
}

/* stylelint-disable scss/dollar-variable-colon-space-after */
.high-shadow {
  box-shadow: 0 24px 24px rgba(0, 0, 0, 0.08);
}

.primary-shadow {
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.08);
}

.secondary-shadow {
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.04);
}

.purple-shadow {
  box-shadow: 0 0 4px 0 #e9e1f8;
}

.sharp-edge {
  border: #eaeaea 1px solid;
}

.background-blur-20 {
  backdrop-filter: blur(10px);
}

.button-glow-shadow {
  box-shadow: 0 0 12px #a6cddc;
}

@media (max-width: 575.98px) {
  .desktopOnly {
    display: none;
  }
}

.mobileOnly {
  display: none;
}
@media (max-width: 575.98px) {
  .mobileOnly {
    display: unset;
  }
}

.hidden {
  display: none;
}

:global(.SignupFeatureRow) {
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 8px;
}
:global(.SignupFeatureRow) .icon {
  flex-shrink: 0;
  width: 24px;
}

:global(.SignupPage) {
  display: flex;
  flex-direction: row;
  gap: 0;
  min-height: calc(100vh - 75px);
  width: 100%;
}
@media (max-width: 575.98px) {
  :global(.SignupPage) {
    flex-direction: column;
    max-height: calc(100vh - 273px + 16px);
    min-height: unset;
    overflow: visible;
  }
}
:global(.SignupPage) .buttonsContainer {
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
}
@media (max-width: 575.98px) {
  :global(.SignupPage) .buttonsContainer {
    gap: 16px;
  }
}
:global(.SignupPage) .buttonsContainer .ContinueWithGoogle {
  background: #747775;
  border-radius: 4px;
  color: #fff;
  display: flex;
  gap: 0;
  height: 40px;
  padding: 0 10px;
  width: 100%;
}
:global(.SignupPage) .buttonsContainer .ContinueWithGoogle:hover {
  box-shadow: 0 1px 2px 0 rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15);
  background: #747775;
  color: #fff;
}
:global(.SignupPage) .buttonsContainer .ContinueWithGoogle.disabled {
  background: #ccc;
  color: #a6a6a6;
}
:global(.SignupPage) .buttonsContainer .ContinueWithGoogle.disabled:hover {
  background: #ccc;
  box-shadow: unset;
  color: #a6a6a6;
}
@media (max-width: 575.98px) {
  :global(.SignupPage) .buttonsContainer .mobileSignupButtons {
    display: flex;
    flex-direction: row;
    gap: 16px;
  }
  :global(.SignupPage) .buttonsContainer .mobileSignupButtons :global(.ContinueWithGoogle) {
    flex-grow: 1;
  }
  :global(.SignupPage) .buttonsContainer .mobileSignupButtons .emailButton.override.colorOverride {
    flex-grow: 1;
    padding: unset;
  }
  :global(.SignupPage) .buttonsContainer .mobileSignupButtons .emailButton.override.colorOverride.lightestPurple {
    background: #e9e1f8;
    border: #5b1dc2 1px solid;
    transition: background-color 0.15s ease-in-out;
  }
}
:global(.SignupPage) .buttonsContainer .emailSection {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
@media (max-width: 575.98px) {
  :global(.SignupPage) .buttonsContainer .emailSection {
    display: none;
  }
  :global(.SignupPage) .buttonsContainer .emailSection.mobileExpanded {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 24px;
  }
}
:global(.SignupPage) .buttonsContainer .emailButton.override.colorOverride {
  align-items: center;
  border: 1px solid #747775;
  color: #1f1f1f;
  display: flex;
  gap: 0;
  height: 40px;
  width: 100%;
}
:global(.SignupPage) .buttonsContainer .emailButton.override.colorOverride:hover {
  box-shadow: 0 1px 2px 0 rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15);
  border: 1px solid #747775;
  color: #1f1f1f;
}
:global(.SignupPage) .buttonsContainer .emailButton.override.colorOverride.disabled {
  border: 1px solid #ccc;
  color: #a6a6a6;
}
:global(.SignupPage) .buttonsContainer .emailButton.override.colorOverride.disabled:hover {
  border: 1px solid #ccc;
  box-shadow: unset;
  color: #a6a6a6;
}
:global(.SignupPage) .buttonsContainer .emailButton.override.colorOverride.disabled :global(.email-icon.btn-icon) path {
  stroke: #d6c7f0;
}
:global(.SignupPage) .buttonsContainer .emailButton.override.colorOverride :global(.email-icon.btn-icon) {
  padding: 0 10px 0 6px;
  position: relative;
}
:global(.SignupPage) .buttonsContainer .emailButton.override.colorOverride :global(.general-oauth-icon.btn-icon) {
  height: 24px;
  padding: 0 10px 0 6px;
  position: relative;
  width: 40px;
}

.marketingSection {
  align-items: center;
  background: linear-gradient(90deg, #e7f8ff 0%, #e3e1ff 100%);
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding-top: 64px;
  width: 100%;
}
@media (max-width: 575.98px) {
  .marketingSection {
    padding-top: 32px;
  }
}

.marketingHeader {
  font-size: 24px;
  font-weight: normal;
  line-height: 150%;
}
.marketingHeader.bold,
.marketingHeader .bold {
  font-weight: 600;
}
.marketingHeader {
  font-weight: 600;
  text-align: center;
  max-width: 448px;
  padding: 0 48px;
}
@media (max-width: 575.98px) {
  .marketingHeader {
    font-size: 18px;
    font-weight: normal;
    line-height: 150%;
  }
  .marketingHeader.bold,
  .marketingHeader .bold {
    font-weight: 600;
  }
  .marketingHeader {
    font-weight: 600;
    text-align: center;
  }
}

.marketingContent {
  align-items: center;
  display: flex;
  flex-direction: column;
}

@media (max-width: 575.98px) {
  .mobileOnlySpacer {
    height: 70px;
  }
}

.primaryIllustration {
  width: 100%;
}

.featureListContent {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 48px;
}

.bannerMobileTop, .banner {
  background: linear-gradient(90deg, #fdf0c6 0%, #ed5e5e 275%);
  padding-bottom: 12px;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 12px;
  width: 100%;
}
.bannerMobileTop:empty, .banner:empty {
  background: none;
  padding: 0;
}

.banner:empty {
  height: 8px;
}
@media (max-width: 575.98px) {
  .banner {
    display: none;
  }
}

.bannerMobileTop {
  display: none;
}
@media (max-width: 575.98px) {
  .bannerMobileTop {
    display: unset;
  }
}

.signupSection {
  width: 100%;
}

.signupOptionsContainer {
  display: flex;
  flex-direction: column;
  gap: 32px;
  min-height: 100%;
  width: 100%;
}
@media (max-width: 575.98px) {
  .signupOptionsContainer {
    background-color: #fff;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    bottom: 0;
    box-shadow: 0 -16px 16px 0 rgba(0, 0, 0, 0.08);
    gap: 16px;
    height: 196px;
    min-height: unset;
    padding: 24px;
    position: fixed;
    transition: height 0.15s ease-in-out;
  }
  .signupOptionsContainer.expanded {
    height: 324px;
    transition: height 0.15s ease-in-out;
  }
}

.signupOptionsContent {
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: 24px auto;
  max-width: 375px;
  min-width: 300px;
  width: 50%;
}
@media (max-width: 575.98px) {
  .signupOptionsContent {
    margin: 0 auto;
    width: 100%;
  }
}

.enterpriseLink {
  margin-top: -8px;
}

.disclaimer {
  font-size: 14px;
  font-weight: normal;
  line-height: 150%;
}
.disclaimer.bold,
.disclaimer .bold {
  font-weight: 600;
}
.disclaimer {
  text-align: center;
  bottom: 64px;
  color: #404040;
  padding: 0 64px 0 72px;
  position: absolute;
}
@media (max-width: 575.98px) {
  .disclaimer {
    font-family: "Red Hat Text", "Helvetica", sans-serif;
    font-size: 12px;
    font-weight: normal;
    line-height: 150%;
  }
  .disclaimer.bold,
  .disclaimer .bold {
    font-weight: 600;
  }
  .disclaimer {
    bottom: 16px;
  }
}

.link {
  color: #000;
  text-decoration: underline;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2hvbWUvcnVubmVyL3dvcmsvZ29ieS9nb2J5L3NlcnZlci9zdGF0aWMvc3JjL2NvbXBvbmVudHMiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NoYXJlZC9zYXNzL19jb25zdHMuc2NzcyIsIi4uLy4uLy4uLy4uL3NoYXJlZC9zYXNzL190eXBvZ3JhcGh5LnNjc3MiLCIuLi8uLi8uLi8uLi9ub2RlX21vZHVsZXMvYm9vdHN0cmFwL3Njc3MvbWl4aW5zL19icmVha3BvaW50cy5zY3NzIiwiLi4vLi4vLi4vLi4vc2hhcmVkL3Nhc3MvX2VsZXZhdGlvbi5zY3NzIiwiU2lnbnVwUGFnZS5tb2R1bGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUE2SkE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQ3BKQTtFQUNFO0VBQ0E7RUFDQTs7QUFFQTtBQUFBO0VBVkE7O0FDd0VFO0VEbkVKO0lBV0k7SUFDQTs7OztBQUlKO0VBQ0U7RUFDQTtFQUNBOztBQUVBO0FBQUE7RUExQkE7O0FDd0VFO0VEbkRKO0lBV0k7SUFDQTs7OztBQW9CSjtFQWZFO0VBQ0E7RUFDQTs7QUFFQTtBQUFBO0VBMUNBOztBQ3dFRTtFRG5CSjtJQUxJO0lBQ0E7Ozs7QUFxQko7RUFWRTtFQUNBO0VBQ0E7O0FBRUE7QUFBQTtFQWhFQTs7O0FBcUZGO0VBVkU7RUFDQTtFQUNBOztBQUVBO0FBQUE7RUEvRUE7OztBQW9HRjtFQVZFO0VBQ0E7RUFDQTs7QUFFQTtBQUFBO0VBOUZBOzs7QUFtSEY7RUFWRTtFQUNBO0VBQ0E7O0FBRUE7QUFBQTtFQTdHQTs7O0FBaUlGO0VBUEU7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7O0FBZUY7RUFQRTtFQUNBO0VBQ0E7RUFDQTtFQUNBOzs7QUFlRjtFQVBFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQW9CRjtFQVZFO0VBQ0E7RUFDQTs7QUFFQTtBQUFBO0VBcEtBOzs7QUEwTEY7RUFWRTtFQUNBO0VBQ0E7O0FBRUE7QUFBQTtFQXBMQTs7O0FBME1GO0VBWEUsYUR2Rlc7RUN3Rlg7RUFDQTtFQUNBOztBQUVBO0FBQUE7RUFwTUE7OztBQWlORjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7O0FBR0Y7RUFFRTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtBQUFBO0VBeE9BOzs7QUEwUEY7RUFYRTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtBQUFBO0VBcFBBOzs7QUErUEY7RUFFRTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtBQUFBO0VBdFFBOzs7QUE0UUY7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTs7O0FBS0Y7RUFDRTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRSxPRDlSSzs7O0FDaVNQO0VBQ0UsT0RuU1U7OztBQ3NTWjtFQUNFLE9EeFNZOzs7QUMyU2Q7RUFDRSxPRDdTYTs7O0FDZ1RmO0VBQ0UsT0Q3U1M7OztBQ2dUWDtFQUNFLE9EaFRXOzs7QUNtVGI7RUFDRSxPRG5UWTs7O0FDc1RkO0VBQ0UsT0RuVU87OztBQ3NVVDtFQUNFLE9EdFVXOzs7QUN5VWI7RUFDRSxPRDdUTTs7O0FDZ1VSO0VBQ0UsT0Q5VE07OztBQ2lVUjtFQUNFLE9EalNJOzs7QUNvU047RUFDRSxPRG5TVTs7O0FDc1NaO0VBQ0UsT0Q5Ulc7OztBQ3FTYjtFQUhFOzs7QUFPRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUQ1TkY7QUczSkE7RUFDRTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTs7O0FBSUY7RUFDRTs7O0FEZ0RFO0VFakVKO0lBRUk7Ozs7QUFJSjtFQUNFOztBRjBERTtFRTNESjtJQUdJOzs7O0FBSUo7RUFDRTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQSxLSmdGTzs7QUk5RVA7RUFDRTtFQUNBOzs7QUFJSjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FGK0JFO0VFcENKO0lBUUk7SUFDQTtJQUNBO0lBQ0E7OztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7O0FGa0JBO0VFdEJGO0lBT0k7OztBQUdGO0VBQ0UsWUplTztFSWRQO0VBQ0EsT0p2Q0U7RUl3Q0Y7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFRHhDSixZQUNFO0VDeUNJLFlKSUs7RUlITCxPSmpEQTs7QUlvREY7RUFDRSxZSjNESTtFSTRESixPSjNERDs7QUk2REM7RUFDRSxZSi9ERTtFSWdFRjtFQUNBLE9KaEVIOztBRXFESDtFRWdCQTtJQUVJO0lBQ0E7SUFDQTs7RUFFQTtJQUNFOztFQUdGO0lBQ0U7SUFDQTs7RUFFQTtJQUNFLFlKaEdLO0lJaUdMO0lBQ0E7OztBQU1SO0VBQ0U7RUFDQTtFQUNBOztBRjFDRjtFRXVDQTtJQU1JOztFQUVBO0lBQ0U7SUFDQTtJQUNBO0lBQ0E7OztBQUtOO0VBQ0U7RUFDQTtFQUVBLE9KdkRXO0VJd0RYO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0VENUdKLFlBQ0U7RUM2R0k7RUFDQSxPSmhFUzs7QUltRVg7RUFDRTtFQUNBLE9KL0hEOztBSWlJQztFQUNFO0VBQ0E7RUFDQSxPSnBJSDs7QUl3SUc7RUFDRSxRSnBKSTs7QUl5SlY7RUFDRTtFQUNBOztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7OztBQU1SO0VBQ0U7RUFDQSxZSmhHVztFSWlHWDtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBRi9HRTtFRXdHSjtJQVNJOzs7O0FBSUo7RUhqSUU7RUFDQTtFQUNBOztBQUVBO0FBQUE7RUFoRUE7O0FHNkxGO0VIN0xFO0VBeVdBO0VHeEtBO0VBQ0E7O0FGMUhFO0VFcUhKO0lIbkdFO0lBQ0E7SUFDQTs7RUFFQTtBQUFBO0lBOUZBOztFRzZMRjtJSDdMRTtJQXlXQTs7OztBRzlKRjtFQUNFO0VBQ0E7RUFDQTs7O0FGdElFO0VFeUlKO0lBRUk7Ozs7QUFJSjtFQUNFOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0UsWUozSVk7RUk0SVo7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQUNFO0VBQ0E7OztBQU9GO0VBQ0U7O0FGN0tBO0VFeUtKO0lBUUk7Ozs7QUFJSjtFQUVFOztBRnZMRTtFRXFMSjtJQUtJOzs7O0FBSUo7RUFDRTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBRnZNRTtFRWtNSjtJQVFJLGtCSjFQSTtJSTJQSjtJQUNBO0lBQ0E7SUFDQTtJQUNBO0lBQ0EsUUFwUjBCO0lBcVIxQjtJQUNBO0lBQ0E7SUFDQTs7RUFFQTtJQUNFLFFBMVJ1QjtJQTJSdkI7Ozs7QUFLTjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBRnBPRTtFRTZOSjtJQVVJO0lBQ0E7Ozs7QUFJSjtFQUNFOzs7QUFHRjtFSHhJRTtFQUNBO0VBQ0E7O0FBRUE7QUFBQTtFQXBMQTs7QUd3VEY7RUhpREU7RUc5Q0E7RUFDQSxPSnRTWTtFSXVTWjtFQUNBOztBRnRQRTtFRWdQSjtJSHpIRSxhRHZGVztJQ3dGWDtJQUNBO0lBQ0E7O0VBRUE7QUFBQTtJQXBNQTs7RUd3VEY7SUFVSTs7OztBQUlKO0VBQ0UsT0o1U007RUk2U04iLCJzb3VyY2VzQ29udGVudCI6WyIvLyBDb2xvcnNcblxuLy8gLS0gQnJhbmQgIC0tIC8vXG5cbiRsaWdodEJsdWU6ICNmMGY3ZmE7XG4kYmx1ZTogI2U5ZjVmNztcbiRkYXJrQmx1ZTogI2Q4ZWJmMjtcbiRkYXJrZXJCbHVlOiAjYTZjZGRjO1xuJGRhcmtlc3RCbHVlOiAjN2JiN2NmO1xuXG4kbGlnaHRlc3RQdXJwbGUyNTogI2U5ZTFmODQwO1xuJGxpZ2h0ZXN0UHVycGxlOiAjZTllMWY4O1xuJGxpZ2h0ZXJQdXJwbGU6ICNkNmM3ZjA7XG4kbGlnaHRQdXJwbGU6ICM2YTRlYmY7XG4kcHVycGxlOiAjNWIxZGMyO1xuJGRhcmtQdXJwbGU6ICM0YjE4YTE7XG4kbWFnaWNQdXJwbGU6ICM5ZDY4ZjQ7XG5cbi8vIC0tIEJhc2UgLS0gLy9cblxuJGxpZ2h0ZXN0R3JheTogI2Y1ZjVmNTtcbiRsaWdodGVyR3JheTogI2VhZWFlYTtcbiRsaWdodEdyYXk6ICNjY2M7XG4kZ3JheTogI2E2YTZhNjtcbiRkYXJrR3JheTogIzc2NzY3NjtcbiRkYXJrZXJHcmF5OiAjNjA2MDYwO1xuJGRhcmtlc3RHcmF5OiAjNDA0MDQwO1xuXG4kd2hpdGU6ICNmZmY7XG4kYWxtb3N0V2hpdGU6ICNmOWY5Zjk7XG4kYWxtb3N0QmxhY2s6ICMxNTEzMWY7XG4kYmxhY2s6ICMwMDA7XG5cbiR0cmFuc3BhcmVudFdoaXRlOiByZ2JhKCNmZmYsIDAuODUpO1xuJG1vcmVUcmFuc3BhcmVudFdoaXRlOiByZ2JhKCNmZmYsIDAuNSk7XG4kdHJhbnNwYXJlbnRCbGFjazY2OiByZ2JhKCMwMDAsIDAuNjYpO1xuJG1vcmVUcmFuc3BhcmVudEJsYWNrOiByZ2JhKCMwMDAsIDAuNzUpO1xuJHRyYW5zcGFyZW50QmxhY2s6IHJnYmEoIzAwMCwgMC44NSk7XG4kdHJhbnNwYXJlbnRHcmF5OiByZ2JhKCMwMDAsIDAuMjUpO1xuJG1vcmVUcmFuc3BhcmVudEdyYXk6IHJnYmEoIzAwMCwgMC4wOCk7XG4kYmxhY2swNTogcmdiYSgjMDAwLCAwLjA1KTtcbiRibGFjazEwOiByZ2JhKCMwMDAsIDAuMSk7XG4kYmxhY2s3MDogcmdiYSgjMDAwLCAwLjcpO1xuJGV2ZW5Nb3JlVHJhbnNwYXJlbnRHcmF5OiByZ2JhKCMwMDAsIDAuMDQpO1xuJHRyYW5zcGFyZW50Qmx1ZTogcmdiYSgjZTlmNWY3ZDksIDAuODUpO1xuJGRhcmtlc3RCbHVlMjU6IHJnYmEoMTIzLCAxODMsIDIwNywgMC4yNSk7XG4kZGFya2VzdEJsdWUzMDogcmdiYSgxMjMsIDE4MywgMjA3LCAwLjMpO1xuXG4vLyAtLSBDb250ZXh0dWFsIC0tIC8vXG5cbiRsaWdodGVyR3JlZW46ICNjNmVhYjg7XG4kbGlnaHRHcmVlbjogI2I0ZTNhMTtcbiRncmVlbjogIzgxY2Y2MTtcbiRkYXJrR3JlZW46ICM2YWM2NDM7XG4kZGFya2VyR3JlZW46ICMzMjg3MGQ7XG4kZGFya2VzdEdyZWVuOiAjMmI3NDBiO1xuXG4kbGlnaHRlclllbGxvdzogI2ZkZjBjNjtcbiRsaWdodFllbGxvdzogI2ZmZWFhNztcbiR5ZWxsb3c6ICNmZmQ1NGY7XG4kZGFya1llbGxvdzogI2ZmYzIwMDtcblxuJGxpZ2h0ZXJSZWQ6ICNmYmUzZTM7XG4kbGlnaHRSZWQ6ICNmZjk4OWQ7XG4kcmVkOiAjZmQ4NjhjO1xuJGRhcmtSZWQ6ICNlZDVlNWU7XG4kZGFya2VyUmVkOiAjZDQzODM4O1xuJGRhcmtlc3RSZWQ6ICNjNTA2MDY7XG5cbi8vIC0tIFRhc2tzIC0tIC8vXG5cbiRsaWdodGVzdE9yYW5nZTogI2ZmZWFkNztcbiRsaWdodGVyT3JhbmdlOiAjZmZkYmJhO1xuJGxpZ2h0T3JhbmdlOiAjZmViZjg0O1xuJG9yYW5nZTogI2ZmOWM0MztcbiRkYXJrT3JhbmdlOiAjZmY4MzEzO1xuXG4vLyAtLSBOb24gQmxvY2sgUGFydHkgQ29sb3JzIC0tIC8vXG5cbiRhcHBsZU1haWxCbHVlOiBsaW5lYXItZ3JhZGllbnQoIzFlNTFlZSwgIzE5ZTZmZik7XG4kZ29vZ2xlR3JheTogIzc0Nzc3NTtcbiRnb29nbGVEYXJrR3JheTogIzFmMWYxZjtcblxuLy8gLS0gR3JhZGllbnRzIC0tIC8vXG4kZm9hbUxpZ2h0ZXN0UHVycGxlOiBsaW5lYXItZ3JhZGllbnQoMTM1ZGVnLCAjZGZmZWU2IDAlLCAjZTllMWY4IDEwMCUpO1xuJG9yYW5nZVB1cnBsZTogbGluZWFyLWdyYWRpZW50KDkyZGVnLCAjZmZlYWQ3IDAlLCAjZTllMWY4IDEwMCUpO1xuJGJsdWVQdXJwbGU6IGxpbmVhci1ncmFkaWVudCg5MGRlZywgI2U3ZjhmZiAwJSwgI2UzZTFmZiAxMDAlKTtcbiRkYXJrZXJCbHVlUHVycGxlOiBsaW5lYXItZ3JhZGllbnQoXG4gIDkwZGVnLFxuICByZ2JhKDEyMywgMTgzLCAyMDcsIDAuMjUpIDE3Ljc5JSxcbiAgcmdiYSgyMDgsIDg4LCAyNDMsIDAuMjUpIDQ5LjA0JSxcbiAgcmdiYSg5MSwgMjgsIDE5NCwgMC4yNSkgMTAwJVxuKTtcbiRhbG1vbmRQZWFjaDogbGluZWFyLWdyYWRpZW50KDkwZGVnLCAjZmRmMGM2IDAlLCAjZWQ1ZTVlIDI3NSUpO1xuXG4kdHJhbnNwYXJlbnRQdXJwbGVHcmFkaWVudDogbGluZWFyLWdyYWRpZW50KFxuICA5MGRlZyxcbiAgcmdiYSgyMDgsIDg4LCAyNDMsIDAuMjUpIDAlLFxuICByZ2JhKDkxLCAyOCwgMTk0LCAwLjI1KSA2MS4xMyVcbik7XG4kcHVycGxlR3JhZGllbnQ6IGxpbmVhci1ncmFkaWVudChcbiAgOTBkZWcsXG4gIHJnYmEoMjA4LCA4OCwgMjQzLCAwLjk1KSAwJSxcbiAgcmdiYSg5MSwgMjgsIDE5NCwgMC45NSkgNjEuMTMlXG4pO1xuXG4vLyBGb250c1xuXG4kZm9udEZhbWlseTogJ1JlZCBIYXQgVGV4dCcsICdIZWx2ZXRpY2EnLCBzYW5zLXNlcmlmO1xuXG4vLyBTcGFjaW5nXG5cbiRzcGFjZXI6IDhweDtcblxuLy8gWi1JbmRpY2VzXG5cbiRvdmVybGF5WkluZGV4OiAxMDAwMDAwMDtcbiRvdmVybGF5TW9kYWxaSW5kZXg6ICRvdmVybGF5WkluZGV4ICsgMTtcbiRzaWRlYmFySGVhZGVyWkluZGV4OiAxO1xuJHNpZGViYXJPdmVybGF5WkluZGV4OiAkc2lkZWJhckhlYWRlclpJbmRleCArIDE7XG4kdG9hc3RaSW5kZXg6ICRvdmVybGF5TW9kYWxaSW5kZXggKyAxO1xuJGhlYWRlclpJbmRleDogMjtcbiRkYXNoYm9hcmRIZWFkZXJaSW5kZXg6ICRoZWFkZXJaSW5kZXggLSAxO1xuJG1vZGFsWkluZGV4OiAkaGVhZGVyWkluZGV4ICsgMTA7XG4kZGFzaGJvYXJkVG9vbHRpcFpJbmRleDogMTtcblxuLy8gU2l6aW5nXG5cbiRkYXNoYm9hcmRIZWFkZXJIZWlnaHQ6IDU2cHg7XG4kZGFzaGJvYXJkTmF2V2lkdGg6IDM0MnB4O1xuJGRhc2hib2FyZE5vdGlmaWNhdGlvblBhbmVsV2lkdGg6IDMzMnB4O1xuJHNpZGViYXJIZWFkZXJIZWlnaHQ6IDY1cHg7XG4kc2lkZWJhcldpZHRoOiA0MDBweDtcblxuJHNpZGViYXJIZWFkZXJGaWx0ZXJIZWlnaHQ6IDUwcHg7XG4kbWF4U2lkZWJhckNvbnRhaW5lclRvcDogNzJweDtcblxuLy8gRGFzaGJvYXJkXG5cbiRkYXNoYm9hcmRQcmV2aWV3VG9vbFRpcFpJbmRleDogMjtcbiRkYXNoYm9hcmROYXZiYXJaSW5kZXg6IDI7XG4kZGFzaGJvYXJkUm93WkluZGV4OiAxO1xuXG4vLyBTaWRlYmFyMlxuXG4kc2lkZWJhcjJBY3Rpb25Gb290ZXJaSW5kZXg6IDI7XG4kc2lkZWJhcjJIZWFkZXJIZWlnaHQ6ICRzcGFjZXIgKiA4ICsgMXB4O1xuJHNpZGViYXIySGVhZGVyWkluZGV4OiA0O1xuJHNpZGViYXIyRHJhd2VyWkluZGV4OiAzO1xuJHNpZGViYXIyTW9kYWxaSW5kZXg6IDU7XG4kc2lkZWJhcjJXaWR0aDogNDM2cHg7XG4kc2lkZWJhcjJEcmF3ZXJXaWR0aDogMzdweDtcblxuLy8gVHJhbnNpdGlvblxuXG4vLyBUaGUgc3R5bGVsaW50LWRpc2FibGUgbGluZSBqdXN0IGJlbG93IGlzIGJlY2F1c2Ugc3R5bGVsaW50IGlzIGluIGNvbmZsaWN0XG4vLyB3aXRoIGhvdyBQcmV0dGllciBmb3JtYXRzIHRoaXMgY29kZVxuLyogc3R5bGVsaW50LWRpc2FibGUgc2Nzcy9kb2xsYXItdmFyaWFibGUtY29sb24tc3BhY2UtYWZ0ZXIgKi9cbiR0cmFuc2l0aW9uOlxuICBiYWNrZ3JvdW5kLWNvbG9yIDAuMTVzIGVhc2UtaW4tb3V0LFxuICBib3JkZXItY29sb3IgMC4xNXMgZWFzZS1pbi1vdXQsXG4gIGJveC1zaGFkb3cgMC4xNXMgZWFzZS1pbi1vdXQsXG4gIGNvbG9yIDAuMTVzIGVhc2UtaW4tb3V0LFxuICBvcGFjaXR5IDAuMTVzIGVhc2UtaW4tb3V0LFxuICBvdXRsaW5lIDAuMTVzIGVhc2UtaW4tb3V0O1xuXG4vLyBTaGFkb3dzXG4kYWdlbnRpY1NpZGViYXJTaGFkb3c6IDAgMjRweCAyNHB4ICRtb3JlVHJhbnNwYXJlbnRHcmF5O1xuIiwiQGltcG9ydCAnLi9jb25zdHMnO1xuQGltcG9ydCAnLi9yZXNwb25zaXZlJztcblxuQG1peGluIGJvbGQoKSB7XG4gIGZvbnQtd2VpZ2h0OiA2MDA7XG59XG5cbi8vIC0tIERpc3BsYXkgLS0gLy9cblxuLmRpc3BsYXkxIHtcbiAgZm9udC1zaXplOiA0OHB4O1xuICBmb250LXdlaWdodDogbm9ybWFsO1xuICBsaW5lLWhlaWdodDogMTI1JTtcblxuICAmLmJvbGQsXG4gIC5ib2xkIHtcbiAgICBAaW5jbHVkZSBib2xkO1xuICB9XG5cbiAgQGluY2x1ZGUgbWVkaWEtYnJlYWtwb2ludC1kb3duKG1kKSB7XG4gICAgZm9udC1zaXplOiAzMHB4O1xuICAgIGxpbmUtaGVpZ2h0OiAxNTAlO1xuICB9XG59XG5cbi5kaXNwbGF5MiB7XG4gIGZvbnQtc2l6ZTogNDBweDtcbiAgZm9udC13ZWlnaHQ6IG5vcm1hbDtcbiAgbGluZS1oZWlnaHQ6IDEyNSU7XG5cbiAgJi5ib2xkLFxuICAuYm9sZCB7XG4gICAgQGluY2x1ZGUgYm9sZDtcbiAgfVxuXG4gIEBpbmNsdWRlIG1lZGlhLWJyZWFrcG9pbnQtZG93bihtZCkge1xuICAgIGZvbnQtc2l6ZTogMjdweDtcbiAgICBsaW5lLWhlaWdodDogMTUwJTtcbiAgfVxufVxuXG5AbWl4aW4gZGlzcGxheTMge1xuICBmb250LXNpemU6IDM2cHg7XG4gIGZvbnQtd2VpZ2h0OiBub3JtYWw7XG4gIGxpbmUtaGVpZ2h0OiAxMjUlO1xuXG4gICYuYm9sZCxcbiAgLmJvbGQge1xuICAgIEBpbmNsdWRlIGJvbGQ7XG4gIH1cblxuICBAaW5jbHVkZSBtZWRpYS1icmVha3BvaW50LWRvd24obWQpIHtcbiAgICBmb250LXNpemU6IDI0cHg7XG4gICAgbGluZS1oZWlnaHQ6IDE1MCU7XG4gIH1cbn1cblxuLmRpc3BsYXkzIHtcbiAgQGluY2x1ZGUgZGlzcGxheTM7XG59XG5cbi8vIC0tIEhlYWRpbmcgLS0gLy9cblxuQG1peGluIGhlYWRpbmcxIHtcbiAgZm9udC1zaXplOiAyNHB4O1xuICBmb250LXdlaWdodDogbm9ybWFsO1xuICBsaW5lLWhlaWdodDogMTUwJTtcblxuICAmLmJvbGQsXG4gIC5ib2xkIHtcbiAgICBAaW5jbHVkZSBib2xkO1xuICB9XG59XG5cbi5oZWFkaW5nMSB7XG4gIEBpbmNsdWRlIGhlYWRpbmcxO1xufVxuXG5AbWl4aW4gaGVhZGluZzIge1xuICBmb250LXNpemU6IDIwcHg7XG4gIGZvbnQtd2VpZ2h0OiBub3JtYWw7XG4gIGxpbmUtaGVpZ2h0OiAxNTAlO1xuXG4gICYuYm9sZCxcbiAgLmJvbGQge1xuICAgIEBpbmNsdWRlIGJvbGQ7XG4gIH1cbn1cblxuLmhlYWRpbmcyIHtcbiAgQGluY2x1ZGUgaGVhZGluZzI7XG59XG5cbkBtaXhpbiBoZWFkaW5nMyB7XG4gIGZvbnQtc2l6ZTogMThweDtcbiAgZm9udC13ZWlnaHQ6IG5vcm1hbDtcbiAgbGluZS1oZWlnaHQ6IDE1MCU7XG5cbiAgJi5ib2xkLFxuICAuYm9sZCB7XG4gICAgQGluY2x1ZGUgYm9sZDtcbiAgfVxufVxuXG4uaGVhZGluZzMge1xuICBAaW5jbHVkZSBoZWFkaW5nMztcbn1cblxuQG1peGluIGhlYWRpbmc0IHtcbiAgZm9udC1zaXplOiAxNnB4O1xuICBmb250LXdlaWdodDogbm9ybWFsO1xuICBsaW5lLWhlaWdodDogMTUwJTtcblxuICAmLmJvbGQsXG4gIC5ib2xkIHtcbiAgICBAaW5jbHVkZSBib2xkO1xuICB9XG59XG5cbi5oZWFkaW5nNCB7XG4gIEBpbmNsdWRlIGhlYWRpbmc0O1xufVxuXG4vLyAtLSBTdWJoZWFkaW5nIC0tIC8vXG5cbkBtaXhpbiBzdWJoZWFkaW5nMSB7XG4gIGZvbnQtc2l6ZTogMTZweDtcbiAgZm9udC13ZWlnaHQ6IGJvbGQ7XG4gIGxldHRlci1zcGFjaW5nOiAxcHg7XG4gIGxpbmUtaGVpZ2h0OiAxNTAlO1xuICB0ZXh0LXRyYW5zZm9ybTogdXBwZXJjYXNlO1xufVxuXG4uc3ViaGVhZGluZzEge1xuICBAaW5jbHVkZSBzdWJoZWFkaW5nMTtcbn1cblxuQG1peGluIHN1YmhlYWRpbmcyIHtcbiAgZm9udC1zaXplOiAxNHB4O1xuICBmb250LXdlaWdodDogYm9sZDtcbiAgbGV0dGVyLXNwYWNpbmc6IDFweDtcbiAgbGluZS1oZWlnaHQ6IDE1MCU7XG4gIHRleHQtdHJhbnNmb3JtOiB1cHBlcmNhc2U7XG59XG5cbi5zdWJoZWFkaW5nMiB7XG4gIEBpbmNsdWRlIHN1YmhlYWRpbmcyO1xufVxuXG5AbWl4aW4gc3ViaGVhZGluZzMge1xuICBmb250LXNpemU6IDEycHg7XG4gIGZvbnQtd2VpZ2h0OiBib2xkO1xuICBsZXR0ZXItc3BhY2luZzogMXB4O1xuICBsaW5lLWhlaWdodDogMTUwJTtcbiAgdGV4dC10cmFuc2Zvcm06IHVwcGVyY2FzZTtcbn1cblxuLnN1YmhlYWRpbmczIHtcbiAgQGluY2x1ZGUgc3ViaGVhZGluZzM7XG59XG5cbi8vIC0tIEJvZHkgLS0gLy9cblxuQG1peGluIGJvZHkxIHtcbiAgZm9udC1zaXplOiAxNnB4O1xuICBmb250LXdlaWdodDogbm9ybWFsO1xuICBsaW5lLWhlaWdodDogMTUwJTtcblxuICAmLmJvbGQsXG4gIC5ib2xkIHtcbiAgICBAaW5jbHVkZSBib2xkO1xuICB9XG59XG5cbi5ib2R5MSxcbiVib2R5MSB7XG4gIEBpbmNsdWRlIGJvZHkxO1xufVxuXG5AbWl4aW4gYm9keTIge1xuICBmb250LXNpemU6IDE0cHg7XG4gIGZvbnQtd2VpZ2h0OiBub3JtYWw7XG4gIGxpbmUtaGVpZ2h0OiAxNTAlO1xuXG4gICYuYm9sZCxcbiAgLmJvbGQge1xuICAgIEBpbmNsdWRlIGJvbGQ7XG4gIH1cbn1cblxuLmJvZHkyIHtcbiAgQGluY2x1ZGUgYm9keTI7XG59XG5cbkBtaXhpbiBib2R5MyB7XG4gIGZvbnQtZmFtaWx5OiAkZm9udEZhbWlseTtcbiAgZm9udC1zaXplOiAxMnB4O1xuICBmb250LXdlaWdodDogbm9ybWFsO1xuICBsaW5lLWhlaWdodDogMTUwJTtcblxuICAmLmJvbGQsXG4gIC5ib2xkIHtcbiAgICBAaW5jbHVkZSBib2xkO1xuICB9XG59XG5cbi5ib2R5MyxcbiVib2R5MyB7XG4gIEBpbmNsdWRlIGJvZHkzO1xufVxuXG4vLyAtLSBJbnRlcmFjdGl2ZSAtLSAvL1xuXG4uYnV0dG9uMSB7XG4gIGZvbnQtc2l6ZTogMTRweDtcbiAgZm9udC13ZWlnaHQ6IGJvbGQ7XG4gIGxldHRlci1zcGFjaW5nOiAxcHg7XG4gIGxpbmUtaGVpZ2h0OiAxMDAlO1xuICB0ZXh0LXRyYW5zZm9ybTogdXBwZXJjYXNlO1xufVxuXG4uYnV0dG9uMiB7XG4gIGZvbnQtc2l6ZTogMTJweDtcbiAgZm9udC13ZWlnaHQ6IGJvbGQ7XG4gIGxldHRlci1zcGFjaW5nOiAxcHg7XG4gIGxpbmUtaGVpZ2h0OiAxMDAlO1xuICB0ZXh0LXRyYW5zZm9ybTogdXBwZXJjYXNlO1xufVxuXG4ubGluazEsXG4lbGluazEge1xuICBmb250LXNpemU6IDE2cHg7XG4gIGZvbnQtd2VpZ2h0OiBub3JtYWw7XG4gIGxpbmUtaGVpZ2h0OiAxNTAlO1xuICB0ZXh0LWRlY29yYXRpb24tbGluZTogdW5kZXJsaW5lO1xuXG4gICYuYm9sZCxcbiAgLmJvbGQge1xuICAgIEBpbmNsdWRlIGJvbGQ7XG4gIH1cbn1cblxuQG1peGluIGxpbmsyIHtcbiAgZm9udC1zaXplOiAxNHB4O1xuICBmb250LXdlaWdodDogbm9ybWFsO1xuICBsaW5lLWhlaWdodDogMTUwJTtcbiAgdGV4dC1kZWNvcmF0aW9uLWxpbmU6IHVuZGVybGluZTtcblxuICAmLmJvbGQsXG4gIC5ib2xkIHtcbiAgICBAaW5jbHVkZSBib2xkO1xuICB9XG59XG5cbi5saW5rMixcbiVsaW5rMiB7XG4gIEBpbmNsdWRlIGxpbmsyO1xufVxuXG4ubGluazMsXG4lbGluazMge1xuICBmb250LXNpemU6IDEycHg7XG4gIGZvbnQtd2VpZ2h0OiBub3JtYWw7XG4gIGxpbmUtaGVpZ2h0OiAxNTAlO1xuICB0ZXh0LWRlY29yYXRpb24tbGluZTogdW5kZXJsaW5lO1xuXG4gICYuYm9sZCxcbiAgLmJvbGQge1xuICAgIEBpbmNsdWRlIGJvbGQ7XG4gIH1cbn1cblxuLnNtYWxsLWxhYmVsMSB7XG4gIGZvbnQtc2l6ZTogMTJweDtcbiAgZm9udC13ZWlnaHQ6IGJvbGQ7XG4gIGxpbmUtaGVpZ2h0OiAxMDAlO1xuICB0ZXh0LXRyYW5zZm9ybTogdXBwZXJjYXNlO1xufVxuXG4uc21hbGwtbGFiZWwyIHtcbiAgZm9udC1zaXplOiAxMHB4O1xuICBmb250LXdlaWdodDogYm9sZDtcbiAgbGluZS1oZWlnaHQ6IDEwMCU7XG4gIHRleHQtdHJhbnNmb3JtOiB1cHBlcmNhc2U7XG59XG5cbi5jdXJzb3ItcG9pbnRlciB7XG4gIGN1cnNvcjogcG9pbnRlcjtcbn1cblxuLy8gLS0gQWRqdXN0bWVudHMgLS0gLy9cblxuLnVuZGVybGluZSB7XG4gIHRleHQtZGVjb3JhdGlvbjogdW5kZXJsaW5lO1xufVxuXG4udXBwZXJjYXNlIHtcbiAgdGV4dC10cmFuc2Zvcm06IHVwcGVyY2FzZTtcbn1cblxuLmxvd2VyY2FzZSB7XG4gIHRleHQtdHJhbnNmb3JtOiBsb3dlcmNhc2U7XG59XG5cbi5uby10ZXh0LXRyYW5zZm9ybSB7XG4gIHRleHQtdHJhbnNmb3JtOiBub25lO1xufVxuXG4uZ3JheSB7XG4gIGNvbG9yOiAkZ3JheTtcbn1cblxuLmxpZ2h0LWdyYXkge1xuICBjb2xvcjogJGxpZ2h0R3JheTtcbn1cblxuLmxpZ2h0ZXItZ3JheSB7XG4gIGNvbG9yOiAkbGlnaHRlckdyYXk7XG59XG5cbi5saWdodGVzdC1ncmF5IHtcbiAgY29sb3I6ICRsaWdodGVzdEdyYXk7XG59XG5cbi5kYXJrLWdyYXkge1xuICBjb2xvcjogJGRhcmtHcmF5O1xufVxuXG4uZGFya2VyLWdyYXkge1xuICBjb2xvcjogJGRhcmtlckdyYXk7XG59XG5cbi5kYXJrZXN0LWdyYXkge1xuICBjb2xvcjogJGRhcmtlc3RHcmF5O1xufVxuXG4ucHVycGxlIHtcbiAgY29sb3I6ICRwdXJwbGU7XG59XG5cbi5kYXJrLXB1cnBsZSB7XG4gIGNvbG9yOiAkZGFya1B1cnBsZTtcbn1cblxuLndoaXRlIHtcbiAgY29sb3I6ICR3aGl0ZTtcbn1cblxuLmJsYWNrIHtcbiAgY29sb3I6ICRibGFjaztcbn1cblxuLnJlZCB7XG4gIGNvbG9yOiAkcmVkO1xufVxuXG4uZGFya2VyLXJlZCB7XG4gIGNvbG9yOiAkZGFya2VyUmVkO1xufVxuXG4uZGFyay1vcmFuZ2Uge1xuICBjb2xvcjogJGRhcmtPcmFuZ2U7XG59XG5cbkBtaXhpbiBjZW50ZXIge1xuICB0ZXh0LWFsaWduOiBjZW50ZXI7XG59XG5cbi5jZW50ZXIge1xuICBAaW5jbHVkZSBjZW50ZXI7XG59XG5cbi5yaWdodCB7XG4gIHRleHQtYWxpZ246IHJpZ2h0O1xufVxuXG4ubm9ybWFsIHtcbiAgZm9udC13ZWlnaHQ6IG5vcm1hbDtcbn1cbiIsIi8vIEJyZWFrcG9pbnQgdmlld3BvcnQgc2l6ZXMgYW5kIG1lZGlhIHF1ZXJpZXMuXG4vL1xuLy8gQnJlYWtwb2ludHMgYXJlIGRlZmluZWQgYXMgYSBtYXAgb2YgKG5hbWU6IG1pbmltdW0gd2lkdGgpLCBvcmRlciBmcm9tIHNtYWxsIHRvIGxhcmdlOlxuLy9cbi8vICAgICh4czogMCwgc206IDU3NnB4LCBtZDogNzY4cHgsIGxnOiA5OTJweCwgeGw6IDEyMDBweCwgeHhsOiAxNDAwcHgpXG4vL1xuLy8gVGhlIG1hcCBkZWZpbmVkIGluIHRoZSBgJGdyaWQtYnJlYWtwb2ludHNgIGdsb2JhbCB2YXJpYWJsZSBpcyB1c2VkIGFzIHRoZSBgJGJyZWFrcG9pbnRzYCBhcmd1bWVudCBieSBkZWZhdWx0LlxuXG4vLyBOYW1lIG9mIHRoZSBuZXh0IGJyZWFrcG9pbnQsIG9yIG51bGwgZm9yIHRoZSBsYXN0IGJyZWFrcG9pbnQuXG4vL1xuLy8gICAgPj4gYnJlYWtwb2ludC1uZXh0KHNtKVxuLy8gICAgbWRcbi8vICAgID4+IGJyZWFrcG9pbnQtbmV4dChzbSwgKHhzOiAwLCBzbTogNTc2cHgsIG1kOiA3NjhweCwgbGc6IDk5MnB4LCB4bDogMTIwMHB4LCB4eGw6IDE0MDBweCkpXG4vLyAgICBtZFxuLy8gICAgPj4gYnJlYWtwb2ludC1uZXh0KHNtLCAkYnJlYWtwb2ludC1uYW1lczogKHhzIHNtIG1kIGxnIHhsIHh4bCkpXG4vLyAgICBtZFxuQGZ1bmN0aW9uIGJyZWFrcG9pbnQtbmV4dCgkbmFtZSwgJGJyZWFrcG9pbnRzOiAkZ3JpZC1icmVha3BvaW50cywgJGJyZWFrcG9pbnQtbmFtZXM6IG1hcC1rZXlzKCRicmVha3BvaW50cykpIHtcbiAgJG46IGluZGV4KCRicmVha3BvaW50LW5hbWVzLCAkbmFtZSk7XG4gIEBpZiBub3QgJG4ge1xuICAgIEBlcnJvciBcImJyZWFrcG9pbnQgYCN7JG5hbWV9YCBub3QgZm91bmQgaW4gYCN7JGJyZWFrcG9pbnRzfWBcIjtcbiAgfVxuICBAcmV0dXJuIGlmKCRuIDwgbGVuZ3RoKCRicmVha3BvaW50LW5hbWVzKSwgbnRoKCRicmVha3BvaW50LW5hbWVzLCAkbiArIDEpLCBudWxsKTtcbn1cblxuLy8gTWluaW11bSBicmVha3BvaW50IHdpZHRoLiBOdWxsIGZvciB0aGUgc21hbGxlc3QgKGZpcnN0KSBicmVha3BvaW50LlxuLy9cbi8vICAgID4+IGJyZWFrcG9pbnQtbWluKHNtLCAoeHM6IDAsIHNtOiA1NzZweCwgbWQ6IDc2OHB4LCBsZzogOTkycHgsIHhsOiAxMjAwcHgsIHh4bDogMTQwMHB4KSlcbi8vICAgIDU3NnB4XG5AZnVuY3Rpb24gYnJlYWtwb2ludC1taW4oJG5hbWUsICRicmVha3BvaW50czogJGdyaWQtYnJlYWtwb2ludHMpIHtcbiAgJG1pbjogbWFwLWdldCgkYnJlYWtwb2ludHMsICRuYW1lKTtcbiAgQHJldHVybiBpZigkbWluICE9IDAsICRtaW4sIG51bGwpO1xufVxuXG4vLyBNYXhpbXVtIGJyZWFrcG9pbnQgd2lkdGguXG4vLyBUaGUgbWF4aW11bSB2YWx1ZSBpcyByZWR1Y2VkIGJ5IDAuMDJweCB0byB3b3JrIGFyb3VuZCB0aGUgbGltaXRhdGlvbnMgb2Zcbi8vIGBtaW4tYCBhbmQgYG1heC1gIHByZWZpeGVzIGFuZCB2aWV3cG9ydHMgd2l0aCBmcmFjdGlvbmFsIHdpZHRocy5cbi8vIFNlZSBodHRwczovL3d3dy53My5vcmcvVFIvbWVkaWFxdWVyaWVzLTQvI21xLW1pbi1tYXhcbi8vIFVzZXMgMC4wMnB4IHJhdGhlciB0aGFuIDAuMDFweCB0byB3b3JrIGFyb3VuZCBhIGN1cnJlbnQgcm91bmRpbmcgYnVnIGluIFNhZmFyaS5cbi8vIFNlZSBodHRwczovL2J1Z3Mud2Via2l0Lm9yZy9zaG93X2J1Zy5jZ2k/aWQ9MTc4MjYxXG4vL1xuLy8gICAgPj4gYnJlYWtwb2ludC1tYXgobWQsICh4czogMCwgc206IDU3NnB4LCBtZDogNzY4cHgsIGxnOiA5OTJweCwgeGw6IDEyMDBweCwgeHhsOiAxNDAwcHgpKVxuLy8gICAgNzY3Ljk4cHhcbkBmdW5jdGlvbiBicmVha3BvaW50LW1heCgkbmFtZSwgJGJyZWFrcG9pbnRzOiAkZ3JpZC1icmVha3BvaW50cykge1xuICAkbWF4OiBtYXAtZ2V0KCRicmVha3BvaW50cywgJG5hbWUpO1xuICBAcmV0dXJuIGlmKCRtYXggYW5kICRtYXggPiAwLCAkbWF4IC0gLjAyLCBudWxsKTtcbn1cblxuLy8gUmV0dXJucyBhIGJsYW5rIHN0cmluZyBpZiBzbWFsbGVzdCBicmVha3BvaW50LCBvdGhlcndpc2UgcmV0dXJucyB0aGUgbmFtZSB3aXRoIGEgZGFzaCBpbiBmcm9udC5cbi8vIFVzZWZ1bCBmb3IgbWFraW5nIHJlc3BvbnNpdmUgdXRpbGl0aWVzLlxuLy9cbi8vICAgID4+IGJyZWFrcG9pbnQtaW5maXgoeHMsICh4czogMCwgc206IDU3NnB4LCBtZDogNzY4cHgsIGxnOiA5OTJweCwgeGw6IDEyMDBweCwgeHhsOiAxNDAwcHgpKVxuLy8gICAgXCJcIiAgKFJldHVybnMgYSBibGFuayBzdHJpbmcpXG4vLyAgICA+PiBicmVha3BvaW50LWluZml4KHNtLCAoeHM6IDAsIHNtOiA1NzZweCwgbWQ6IDc2OHB4LCBsZzogOTkycHgsIHhsOiAxMjAwcHgsIHh4bDogMTQwMHB4KSlcbi8vICAgIFwiLXNtXCJcbkBmdW5jdGlvbiBicmVha3BvaW50LWluZml4KCRuYW1lLCAkYnJlYWtwb2ludHM6ICRncmlkLWJyZWFrcG9pbnRzKSB7XG4gIEByZXR1cm4gaWYoYnJlYWtwb2ludC1taW4oJG5hbWUsICRicmVha3BvaW50cykgPT0gbnVsbCwgXCJcIiwgXCItI3skbmFtZX1cIik7XG59XG5cbi8vIE1lZGlhIG9mIGF0IGxlYXN0IHRoZSBtaW5pbXVtIGJyZWFrcG9pbnQgd2lkdGguIE5vIHF1ZXJ5IGZvciB0aGUgc21hbGxlc3QgYnJlYWtwb2ludC5cbi8vIE1ha2VzIHRoZSBAY29udGVudCBhcHBseSB0byB0aGUgZ2l2ZW4gYnJlYWtwb2ludCBhbmQgd2lkZXIuXG5AbWl4aW4gbWVkaWEtYnJlYWtwb2ludC11cCgkbmFtZSwgJGJyZWFrcG9pbnRzOiAkZ3JpZC1icmVha3BvaW50cykge1xuICAkbWluOiBicmVha3BvaW50LW1pbigkbmFtZSwgJGJyZWFrcG9pbnRzKTtcbiAgQGlmICRtaW4ge1xuICAgIEBtZWRpYSAobWluLXdpZHRoOiAkbWluKSB7XG4gICAgICBAY29udGVudDtcbiAgICB9XG4gIH0gQGVsc2Uge1xuICAgIEBjb250ZW50O1xuICB9XG59XG5cbi8vIE1lZGlhIG9mIGF0IG1vc3QgdGhlIG1heGltdW0gYnJlYWtwb2ludCB3aWR0aC4gTm8gcXVlcnkgZm9yIHRoZSBsYXJnZXN0IGJyZWFrcG9pbnQuXG4vLyBNYWtlcyB0aGUgQGNvbnRlbnQgYXBwbHkgdG8gdGhlIGdpdmVuIGJyZWFrcG9pbnQgYW5kIG5hcnJvd2VyLlxuQG1peGluIG1lZGlhLWJyZWFrcG9pbnQtZG93bigkbmFtZSwgJGJyZWFrcG9pbnRzOiAkZ3JpZC1icmVha3BvaW50cykge1xuICAkbWF4OiBicmVha3BvaW50LW1heCgkbmFtZSwgJGJyZWFrcG9pbnRzKTtcbiAgQGlmICRtYXgge1xuICAgIEBtZWRpYSAobWF4LXdpZHRoOiAkbWF4KSB7XG4gICAgICBAY29udGVudDtcbiAgICB9XG4gIH0gQGVsc2Uge1xuICAgIEBjb250ZW50O1xuICB9XG59XG5cbi8vIE1lZGlhIHRoYXQgc3BhbnMgbXVsdGlwbGUgYnJlYWtwb2ludCB3aWR0aHMuXG4vLyBNYWtlcyB0aGUgQGNvbnRlbnQgYXBwbHkgYmV0d2VlbiB0aGUgbWluIGFuZCBtYXggYnJlYWtwb2ludHNcbkBtaXhpbiBtZWRpYS1icmVha3BvaW50LWJldHdlZW4oJGxvd2VyLCAkdXBwZXIsICRicmVha3BvaW50czogJGdyaWQtYnJlYWtwb2ludHMpIHtcbiAgJG1pbjogYnJlYWtwb2ludC1taW4oJGxvd2VyLCAkYnJlYWtwb2ludHMpO1xuICAkbWF4OiBicmVha3BvaW50LW1heCgkdXBwZXIsICRicmVha3BvaW50cyk7XG5cbiAgQGlmICRtaW4gIT0gbnVsbCBhbmQgJG1heCAhPSBudWxsIHtcbiAgICBAbWVkaWEgKG1pbi13aWR0aDogJG1pbikgYW5kIChtYXgtd2lkdGg6ICRtYXgpIHtcbiAgICAgIEBjb250ZW50O1xuICAgIH1cbiAgfSBAZWxzZSBpZiAkbWF4ID09IG51bGwge1xuICAgIEBpbmNsdWRlIG1lZGlhLWJyZWFrcG9pbnQtdXAoJGxvd2VyLCAkYnJlYWtwb2ludHMpIHtcbiAgICAgIEBjb250ZW50O1xuICAgIH1cbiAgfSBAZWxzZSBpZiAkbWluID09IG51bGwge1xuICAgIEBpbmNsdWRlIG1lZGlhLWJyZWFrcG9pbnQtZG93bigkdXBwZXIsICRicmVha3BvaW50cykge1xuICAgICAgQGNvbnRlbnQ7XG4gICAgfVxuICB9XG59XG5cbi8vIE1lZGlhIGJldHdlZW4gdGhlIGJyZWFrcG9pbnQncyBtaW5pbXVtIGFuZCBtYXhpbXVtIHdpZHRocy5cbi8vIE5vIG1pbmltdW0gZm9yIHRoZSBzbWFsbGVzdCBicmVha3BvaW50LCBhbmQgbm8gbWF4aW11bSBmb3IgdGhlIGxhcmdlc3Qgb25lLlxuLy8gTWFrZXMgdGhlIEBjb250ZW50IGFwcGx5IG9ubHkgdG8gdGhlIGdpdmVuIGJyZWFrcG9pbnQsIG5vdCB2aWV3cG9ydHMgYW55IHdpZGVyIG9yIG5hcnJvd2VyLlxuQG1peGluIG1lZGlhLWJyZWFrcG9pbnQtb25seSgkbmFtZSwgJGJyZWFrcG9pbnRzOiAkZ3JpZC1icmVha3BvaW50cykge1xuICAkbWluOiAgYnJlYWtwb2ludC1taW4oJG5hbWUsICRicmVha3BvaW50cyk7XG4gICRuZXh0OiBicmVha3BvaW50LW5leHQoJG5hbWUsICRicmVha3BvaW50cyk7XG4gICRtYXg6ICBicmVha3BvaW50LW1heCgkbmV4dCwgJGJyZWFrcG9pbnRzKTtcblxuICBAaWYgJG1pbiAhPSBudWxsIGFuZCAkbWF4ICE9IG51bGwge1xuICAgIEBtZWRpYSAobWluLXdpZHRoOiAkbWluKSBhbmQgKG1heC13aWR0aDogJG1heCkge1xuICAgICAgQGNvbnRlbnQ7XG4gICAgfVxuICB9IEBlbHNlIGlmICRtYXggPT0gbnVsbCB7XG4gICAgQGluY2x1ZGUgbWVkaWEtYnJlYWtwb2ludC11cCgkbmFtZSwgJGJyZWFrcG9pbnRzKSB7XG4gICAgICBAY29udGVudDtcbiAgICB9XG4gIH0gQGVsc2UgaWYgJG1pbiA9PSBudWxsIHtcbiAgICBAaW5jbHVkZSBtZWRpYS1icmVha3BvaW50LWRvd24oJG5leHQsICRicmVha3BvaW50cykge1xuICAgICAgQGNvbnRlbnQ7XG4gICAgfVxuICB9XG59XG4iLCJAaW1wb3J0ICcuL2NvbnN0cyc7XG5cbi5oaWdoLXNoYWRvdyB7XG4gIGJveC1zaGFkb3c6IDAgMjRweCAyNHB4ICRtb3JlVHJhbnNwYXJlbnRHcmF5O1xufVxuXG4ucHJpbWFyeS1zaGFkb3cge1xuICBib3gtc2hhZG93OiAwIDAgMTZweCAkbW9yZVRyYW5zcGFyZW50R3JheTtcbn1cblxuLnNlY29uZGFyeS1zaGFkb3cge1xuICBib3gtc2hhZG93OiAwIDAgMTZweCAkZXZlbk1vcmVUcmFuc3BhcmVudEdyYXk7XG59XG5cbi5wdXJwbGUtc2hhZG93IHtcbiAgYm94LXNoYWRvdzogMCAwIDRweCAwICRsaWdodGVzdFB1cnBsZTtcbn1cblxuLnNoYXJwLWVkZ2Uge1xuICBib3JkZXI6ICRsaWdodGVyR3JheSAxcHggc29saWQ7XG59XG5cbi5iYWNrZ3JvdW5kLWJsdXItMjAge1xuICBiYWNrZHJvcC1maWx0ZXI6IGJsdXIoMTBweCk7XG59XG5cbi8vIFVzZWQgdG8gZW1waGFzaXplIHNvbWUgQ1RBc1xuLmJ1dHRvbi1nbG93LXNoYWRvdyB7XG4gIGJveC1zaGFkb3c6IDAgMCAxMnB4ICRkYXJrZXJCbHVlO1xufVxuXG4vLyBOb24tQmxvY2sgUGFydHkgc3R5bGVzXG5cbkBtaXhpbiBnb29nbGUtc2hhZG93KCkge1xuICBib3gtc2hhZG93OlxuICAgIDAgMXB4IDJweCAwIHJnYmEoNjAsIDY0LCA2NywgMC4zKSxcbiAgICAwIDFweCAzcHggMXB4IHJnYmEoNjAsIDY0LCA2NywgMC4xNSk7XG59XG4iLCJAaW1wb3J0ICcuLi9zYXNzL2Zvcm0nO1xuQGltcG9ydCAnJHNoYXJlZFNhc3MvY29uc3RzJztcbkBpbXBvcnQgJyRzaGFyZWRTYXNzL3Jlc3BvbnNpdmUnO1xuQGltcG9ydCAnJHNoYXJlZFNhc3MvdHlwb2dyYXBoeSc7XG5AaW1wb3J0ICckc2hhcmVkU2Fzcy9lbGV2YXRpb24nO1xuXG4kbW9iaWxlRm9vdGVySGVpZ2h0OiAyNzNweDtcblxuJG1vYmlsZUZvb3RlckNvbGxhcHNlZEhlaWdodDogMTk2cHg7XG4kbW9iaWxlRm9vdGVyRXhwYW5kZWRIZWlnaHQ6IDMyNHB4O1xuXG4uZGVza3RvcE9ubHkge1xuICBAaW5jbHVkZSBtZWRpYS1icmVha3BvaW50LWRvd24oc20pIHtcbiAgICBkaXNwbGF5OiBub25lO1xuICB9XG59XG5cbi5tb2JpbGVPbmx5IHtcbiAgZGlzcGxheTogbm9uZTtcbiAgQGluY2x1ZGUgbWVkaWEtYnJlYWtwb2ludC1kb3duKHNtKSB7XG4gICAgZGlzcGxheTogdW5zZXQ7XG4gIH1cbn1cblxuLmhpZGRlbiB7XG4gIGRpc3BsYXk6IG5vbmU7XG59XG5cbjpnbG9iYWwoLlNpZ251cEZlYXR1cmVSb3cpIHtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IHJvdztcbiAgZ2FwOiAkc3BhY2VyO1xuXG4gIC5pY29uIHtcbiAgICBmbGV4LXNocmluazogMDtcbiAgICB3aWR0aDogMjRweDtcbiAgfVxufVxuXG46Z2xvYmFsKC5TaWdudXBQYWdlKSB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiByb3c7XG4gIGdhcDogMDtcbiAgbWluLWhlaWdodDogY2FsYygxMDB2aCAtIDc1cHgpO1xuICB3aWR0aDogMTAwJTtcblxuICBAaW5jbHVkZSBtZWRpYS1icmVha3BvaW50LWRvd24oc20pIHtcbiAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgIG1heC1oZWlnaHQ6IGNhbGMoMTAwdmggLSAkbW9iaWxlRm9vdGVySGVpZ2h0ICsgMTZweCk7XG4gICAgbWluLWhlaWdodDogdW5zZXQ7XG4gICAgb3ZlcmZsb3c6IHZpc2libGU7XG4gIH1cblxuICAuYnV0dG9uc0NvbnRhaW5lciB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgIGdhcDogNCAqICRzcGFjZXI7XG4gICAgd2lkdGg6IDEwMCU7XG5cbiAgICBAaW5jbHVkZSBtZWRpYS1icmVha3BvaW50LWRvd24oc20pIHtcbiAgICAgIGdhcDogMiAqICRzcGFjZXI7XG4gICAgfVxuXG4gICAgLkNvbnRpbnVlV2l0aEdvb2dsZSB7XG4gICAgICBiYWNrZ3JvdW5kOiAkZ29vZ2xlR3JheTtcbiAgICAgIGJvcmRlci1yYWRpdXM6IDRweDtcbiAgICAgIGNvbG9yOiAkd2hpdGU7XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgZ2FwOiAwO1xuICAgICAgaGVpZ2h0OiA0MHB4OyAvLyB0byBtYXRjaCB0aGUgaGVpZ2h0IG9mIHRoZSBlbWFpbCBidXR0b25cbiAgICAgIHBhZGRpbmc6IDAgMTBweDtcbiAgICAgIHdpZHRoOiAxMDAlO1xuXG4gICAgICAmOmhvdmVyIHtcbiAgICAgICAgQGluY2x1ZGUgZ29vZ2xlLXNoYWRvdztcbiAgICAgICAgYmFja2dyb3VuZDogJGdvb2dsZUdyYXk7XG4gICAgICAgIGNvbG9yOiAkd2hpdGU7XG4gICAgICB9XG5cbiAgICAgICYuZGlzYWJsZWQge1xuICAgICAgICBiYWNrZ3JvdW5kOiAkbGlnaHRHcmF5O1xuICAgICAgICBjb2xvcjogJGdyYXk7XG5cbiAgICAgICAgJjpob3ZlciB7XG4gICAgICAgICAgYmFja2dyb3VuZDogJGxpZ2h0R3JheTtcbiAgICAgICAgICBib3gtc2hhZG93OiB1bnNldDtcbiAgICAgICAgICBjb2xvcjogJGdyYXk7XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9XG5cbiAgICAubW9iaWxlU2lnbnVwQnV0dG9ucyB7XG4gICAgICBAaW5jbHVkZSBtZWRpYS1icmVha3BvaW50LWRvd24oc20pIHtcbiAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAgZmxleC1kaXJlY3Rpb246IHJvdztcbiAgICAgICAgZ2FwOiAyICogJHNwYWNlcjtcblxuICAgICAgICA6Z2xvYmFsKC5Db250aW51ZVdpdGhHb29nbGUpIHtcbiAgICAgICAgICBmbGV4LWdyb3c6IDE7XG4gICAgICAgIH1cblxuICAgICAgICAuZW1haWxCdXR0b24ub3ZlcnJpZGUuY29sb3JPdmVycmlkZSB7XG4gICAgICAgICAgZmxleC1ncm93OiAxO1xuICAgICAgICAgIHBhZGRpbmc6IHVuc2V0O1xuXG4gICAgICAgICAgJi5saWdodGVzdFB1cnBsZSB7XG4gICAgICAgICAgICBiYWNrZ3JvdW5kOiAkbGlnaHRlc3RQdXJwbGU7XG4gICAgICAgICAgICBib3JkZXI6ICRwdXJwbGUgMXB4IHNvbGlkO1xuICAgICAgICAgICAgdHJhbnNpdGlvbjogYmFja2dyb3VuZC1jb2xvciAwLjE1cyBlYXNlLWluLW91dDtcbiAgICAgICAgICB9XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9XG5cbiAgICAuZW1haWxTZWN0aW9uIHtcbiAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgICAgZ2FwOiAyICogJHNwYWNlcjtcblxuICAgICAgQGluY2x1ZGUgbWVkaWEtYnJlYWtwb2ludC1kb3duKHNtKSB7XG4gICAgICAgIGRpc3BsYXk6IG5vbmU7XG5cbiAgICAgICAgJi5tb2JpbGVFeHBhbmRlZCB7XG4gICAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgICAgICAgIGdhcDogMiAqICRzcGFjZXI7XG4gICAgICAgICAgbWFyZ2luLXRvcDogMyAqICRzcGFjZXI7XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9XG5cbiAgICAuZW1haWxCdXR0b24ub3ZlcnJpZGUuY29sb3JPdmVycmlkZSB7XG4gICAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgICAgYm9yZGVyOiAxcHggc29saWQgJGdvb2dsZUdyYXk7XG5cbiAgICAgIGNvbG9yOiAkZ29vZ2xlRGFya0dyYXk7XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgZ2FwOiAwO1xuICAgICAgaGVpZ2h0OiA0MHB4OyAvLyB0byBtYXRjaCB0aGUgaGVpZ2h0IG9mIHRoZSBnb29nbGUgYnV0dG9uXG4gICAgICB3aWR0aDogMTAwJTtcblxuICAgICAgJjpob3ZlciB7XG4gICAgICAgIEBpbmNsdWRlIGdvb2dsZS1zaGFkb3c7XG4gICAgICAgIGJvcmRlcjogMXB4IHNvbGlkICRnb29nbGVHcmF5O1xuICAgICAgICBjb2xvcjogJGdvb2dsZURhcmtHcmF5O1xuICAgICAgfVxuXG4gICAgICAmLmRpc2FibGVkIHtcbiAgICAgICAgYm9yZGVyOiAxcHggc29saWQgJGxpZ2h0R3JheTtcbiAgICAgICAgY29sb3I6ICRncmF5O1xuXG4gICAgICAgICY6aG92ZXIge1xuICAgICAgICAgIGJvcmRlcjogMXB4IHNvbGlkICRsaWdodEdyYXk7XG4gICAgICAgICAgYm94LXNoYWRvdzogdW5zZXQ7XG4gICAgICAgICAgY29sb3I6ICRncmF5O1xuICAgICAgICB9XG5cbiAgICAgICAgOmdsb2JhbCguZW1haWwtaWNvbi5idG4taWNvbikge1xuICAgICAgICAgIHBhdGgge1xuICAgICAgICAgICAgc3Ryb2tlOiAkbGlnaHRlclB1cnBsZTtcbiAgICAgICAgICB9XG4gICAgICAgIH1cbiAgICAgIH1cblxuICAgICAgOmdsb2JhbCguZW1haWwtaWNvbi5idG4taWNvbikge1xuICAgICAgICBwYWRkaW5nOiAwIDEwcHggMCA2cHg7XG4gICAgICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgICAgIH1cblxuICAgICAgOmdsb2JhbCguZ2VuZXJhbC1vYXV0aC1pY29uLmJ0bi1pY29uKSB7XG4gICAgICAgIGhlaWdodDogMjRweDtcbiAgICAgICAgcGFkZGluZzogMCAxMHB4IDAgNnB4O1xuICAgICAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gICAgICAgIHdpZHRoOiA0MHB4O1xuICAgICAgfVxuICAgIH1cbiAgfVxufVxuXG4ubWFya2V0aW5nU2VjdGlvbiB7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGJhY2tncm91bmQ6ICRibHVlUHVycGxlO1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBnYXA6IDQgKiAkc3BhY2VyO1xuICBwYWRkaW5nLXRvcDogOCAqICRzcGFjZXI7XG4gIHdpZHRoOiAxMDAlO1xuICBAaW5jbHVkZSBtZWRpYS1icmVha3BvaW50LWRvd24oc20pIHtcbiAgICBwYWRkaW5nLXRvcDogNCAqICRzcGFjZXI7XG4gIH1cbn1cblxuLm1hcmtldGluZ0hlYWRlciB7XG4gIEBpbmNsdWRlIGhlYWRpbmcxO1xuICBAaW5jbHVkZSBib2xkO1xuICBAaW5jbHVkZSBjZW50ZXI7XG4gIG1heC13aWR0aDogNDQ4cHg7XG4gIHBhZGRpbmc6IDAgNiAqICRzcGFjZXI7XG5cbiAgQGluY2x1ZGUgbWVkaWEtYnJlYWtwb2ludC1kb3duKHNtKSB7XG4gICAgQGluY2x1ZGUgaGVhZGluZzM7XG4gICAgQGluY2x1ZGUgYm9sZDtcbiAgICBAaW5jbHVkZSBjZW50ZXI7XG4gIH1cbn1cblxuLm1hcmtldGluZ0NvbnRlbnQge1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xufVxuXG4ubW9iaWxlT25seVNwYWNlciB7XG4gIEBpbmNsdWRlIG1lZGlhLWJyZWFrcG9pbnQtZG93bihzbSkge1xuICAgIGhlaWdodDogNzBweDtcbiAgfVxufVxuXG4ucHJpbWFyeUlsbHVzdHJhdGlvbiB7XG4gIHdpZHRoOiAxMDAlO1xufVxuXG4uZmVhdHVyZUxpc3RDb250ZW50IHtcbiAgYWxpZ24taXRlbXM6IGZsZXgtc3RhcnQ7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIGdhcDogOHB4O1xuICBwYWRkaW5nOiAwIDYgKiAkc3BhY2VyO1xufVxuXG4lYmFzZS1iYW5uZXIge1xuICBiYWNrZ3JvdW5kOiAkYWxtb25kUGVhY2g7XG4gIHBhZGRpbmctYm90dG9tOiAkc3BhY2VyICogMS41O1xuICBwYWRkaW5nLWxlZnQ6ICRzcGFjZXIgKiAyO1xuICBwYWRkaW5nLXJpZ2h0OiAkc3BhY2VyICogMjtcbiAgcGFkZGluZy10b3A6ICRzcGFjZXIgKiAxLjU7XG4gIHdpZHRoOiAxMDAlO1xuXG4gICY6ZW1wdHkge1xuICAgIGJhY2tncm91bmQ6IG5vbmU7XG4gICAgcGFkZGluZzogMDtcbiAgfVxufVxuXG4uYmFubmVyIHtcbiAgQGV4dGVuZCAlYmFzZS1iYW5uZXI7XG5cbiAgJjplbXB0eSB7XG4gICAgaGVpZ2h0OiA4cHg7XG4gIH1cblxuICBAaW5jbHVkZSBtZWRpYS1icmVha3BvaW50LWRvd24oc20pIHtcbiAgICBkaXNwbGF5OiBub25lO1xuICB9XG59XG5cbi5iYW5uZXJNb2JpbGVUb3Age1xuICBAZXh0ZW5kICViYXNlLWJhbm5lcjtcbiAgZGlzcGxheTogbm9uZTtcblxuICBAaW5jbHVkZSBtZWRpYS1icmVha3BvaW50LWRvd24oc20pIHtcbiAgICBkaXNwbGF5OiB1bnNldDtcbiAgfVxufVxuXG4uc2lnbnVwU2VjdGlvbiB7XG4gIHdpZHRoOiAxMDAlO1xufVxuXG4uc2lnbnVwT3B0aW9uc0NvbnRhaW5lciB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIGdhcDogNCAqICRzcGFjZXI7XG4gIG1pbi1oZWlnaHQ6IDEwMCU7XG4gIHdpZHRoOiAxMDAlO1xuXG4gIEBpbmNsdWRlIG1lZGlhLWJyZWFrcG9pbnQtZG93bihzbSkge1xuICAgIGJhY2tncm91bmQtY29sb3I6ICR3aGl0ZTtcbiAgICBib3JkZXItdG9wLWxlZnQtcmFkaXVzOiAxNnB4O1xuICAgIGJvcmRlci10b3AtcmlnaHQtcmFkaXVzOiAxNnB4O1xuICAgIGJvdHRvbTogMDtcbiAgICBib3gtc2hhZG93OiAwIC0xNnB4IDE2cHggMCAkbW9yZVRyYW5zcGFyZW50R3JheTtcbiAgICBnYXA6IDIgKiAkc3BhY2VyO1xuICAgIGhlaWdodDogJG1vYmlsZUZvb3RlckNvbGxhcHNlZEhlaWdodDtcbiAgICBtaW4taGVpZ2h0OiB1bnNldDtcbiAgICBwYWRkaW5nOiAyNHB4O1xuICAgIHBvc2l0aW9uOiBmaXhlZDtcbiAgICB0cmFuc2l0aW9uOiBoZWlnaHQgMC4xNXMgZWFzZS1pbi1vdXQ7XG5cbiAgICAmLmV4cGFuZGVkIHtcbiAgICAgIGhlaWdodDogJG1vYmlsZUZvb3RlckV4cGFuZGVkSGVpZ2h0O1xuICAgICAgdHJhbnNpdGlvbjogaGVpZ2h0IDAuMTVzIGVhc2UtaW4tb3V0O1xuICAgIH1cbiAgfVxufVxuXG4uc2lnbnVwT3B0aW9uc0NvbnRlbnQge1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBtYXJnaW46IDMgKiAkc3BhY2VyIGF1dG87XG4gIG1heC13aWR0aDogMzc1cHg7XG4gIG1pbi13aWR0aDogMzAwcHg7XG4gIHdpZHRoOiA1MCU7XG5cbiAgQGluY2x1ZGUgbWVkaWEtYnJlYWtwb2ludC1kb3duKHNtKSB7XG4gICAgbWFyZ2luOiAwIGF1dG87XG4gICAgd2lkdGg6IDEwMCU7XG4gIH1cbn1cblxuLmVudGVycHJpc2VMaW5rIHtcbiAgbWFyZ2luLXRvcDogLThweDtcbn1cblxuLmRpc2NsYWltZXIge1xuICBAaW5jbHVkZSBib2R5MjtcbiAgQGluY2x1ZGUgY2VudGVyO1xuICBib3R0b206IDggKiAkc3BhY2VyO1xuICBjb2xvcjogJGRhcmtlc3RHcmF5O1xuICBwYWRkaW5nOiAwIDggKiAkc3BhY2VyIDAgOSAqICRzcGFjZXI7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcblxuICBAaW5jbHVkZSBtZWRpYS1icmVha3BvaW50LWRvd24oc20pIHtcbiAgICBAaW5jbHVkZSBib2R5MztcbiAgICBib3R0b206IDIgKiAkc3BhY2VyO1xuICB9XG59XG5cbi5saW5rIHtcbiAgY29sb3I6ICRibGFjaztcbiAgdGV4dC1kZWNvcmF0aW9uOiB1bmRlcmxpbmU7XG59XG4iXX0= */